// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:where(.vuetify-styles) .v-time-picker.v-picker {
  min-width: 328px;
}
:where(.vuetify-styles) .v-time-picker .v-picker__body, :where(.vuetify-styles) .v-time-picker-controls__field-label, :where(.vuetify-styles) .v-time-picker .v-field {
  transition-duration: 0.25s;
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
  transition-property: transform, max-height, opacity, font-size;
}
@media (prefers-reduced-motion: reduce) {
  :where(.vuetify-styles) .v-time-picker .v-picker__body, :where(.vuetify-styles) .v-time-picker-controls__field-label, :where(.vuetify-styles) .v-time-picker .v-field {
    transition: none;
  }
}
:where(.vuetify-styles) .v-time-picker .v-picker__body {
  transition-behavior: allow-discrete;
  max-height: calc-size(max-content, size);
}
:where(.vuetify-styles) .v-time-picker--variant-input .v-picker__body {
  transform: scale(0);
  max-height: 0;
}`, "",{"version":3,"sources":["webpack://./node_modules/vuetify/lib/components/VTimePicker/VTimePicker.css"],"names":[],"mappings":"AAAA;EACE,gBAAgB;AAClB;AACA;EAEE,0BAA0B;EAC1B,wDAAwD;EACxD,8DAA8D;AAChE;AACA;EACE;IAEE,gBAAgB;EAClB;AACF;AACA;EACE,mCAAmC;EACnC,wCAAwC;AAC1C;AACA;EACE,mBAAmB;EACnB,aAAa;AACf","sourcesContent":[".v-time-picker.v-picker {\n  min-width: 328px;\n}\n.v-time-picker .v-picker__body, .v-time-picker-controls__field-label,\n.v-time-picker .v-field {\n  transition-duration: 0.25s;\n  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);\n  transition-property: transform, max-height, opacity, font-size;\n}\n@media (prefers-reduced-motion: reduce) {\n  .v-time-picker .v-picker__body, .v-time-picker-controls__field-label,\n  .v-time-picker .v-field {\n    transition: none;\n  }\n}\n.v-time-picker .v-picker__body {\n  transition-behavior: allow-discrete;\n  max-height: calc-size(max-content, size);\n}\n.v-time-picker--variant-input .v-picker__body {\n  transform: scale(0);\n  max-height: 0;\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
